import { useSiteContent } from '@/context/SiteContentContext';

export default function Footer() {
  const { content } = useSiteContent();
  const f = content.footer;
  const waNumber = f.phone2.replace(/\D/g, '');

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-teal-950 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img src="https://public.readdy.ai/ai/img_res/dfcf48ea-5680-4d6a-82aa-016ba692e447.png" alt="GeoEng Systems Logo" className="h-12 w-auto object-contain brightness-0 invert" />
            </div>
            <p className="text-teal-300/70 text-sm leading-relaxed mb-6 whitespace-pre-line">{f.tagline}</p>
            <div className="flex gap-3">
              {['ri-linkedin-fill','ri-twitter-fill','ri-facebook-fill'].map((icon) => (
                <a key={icon} href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center rounded-lg bg-teal-800 hover:bg-teal-600 transition-colors cursor-pointer"><i className={`${icon} text-white text-sm`}></i></a>
              ))}
            </div>
          </div>
          <div>
            <h5 className="text-teal-400 text-xs font-semibold tracking-widest uppercase mb-4">Services</h5>
            <ul className="space-y-2.5">
              {['GIS & Surveying','IT Consulting','Research Services','Training & Capacity Building','Cloud Services'].map((item) => (
                <li key={item}><button onClick={() => handleNav('#services')} className="text-teal-200/70 hover:text-teal-300 text-sm transition-colors cursor-pointer text-left">{item}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <h5 className="text-teal-400 text-xs font-semibold tracking-widest uppercase mb-4">Company</h5>
            <ul className="space-y-2.5">
              {[{ label: 'About Us', href: '#about' },{ label: 'Our Team', href: '#team' },{ label: 'Our Clients', href: '#clients' },{ label: 'Contact Us', href: '#contact' }].map((item) => (
                <li key={item.label}><button onClick={() => handleNav(item.href)} className="text-teal-200/70 hover:text-teal-300 text-sm transition-colors cursor-pointer text-left">{item.label}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <h5 className="text-teal-400 text-xs font-semibold tracking-widest uppercase mb-4">Contact</h5>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-teal-200/70 text-sm"><i className="ri-map-pin-line text-teal-400 mt-0.5 shrink-0"></i><span className="whitespace-pre-line">{f.address}</span></li>
              <li className="flex items-center gap-2 text-teal-200/70 text-sm"><i className="ri-phone-line text-teal-400 shrink-0"></i>{f.phone1}</li>
              <li><a href={`https://wa.me/${waNumber}`} target="_blank" rel="nofollow noreferrer" className="flex items-center gap-2 text-teal-200/70 hover:text-teal-300 text-sm transition-colors cursor-pointer"><i className="ri-whatsapp-line text-teal-400 shrink-0"></i>{f.phone2}</a></li>
              <li className="flex items-center gap-2 text-teal-200/70 text-sm"><i className="ri-mail-line text-teal-400 shrink-0"></i>{f.email}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-teal-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-teal-400/60 text-xs">&copy; 2025 GeoEng Systems Ltd. All rights reserved.</p>
          <div className="flex gap-4">
            <a href="#" rel="nofollow" className="text-teal-400/60 hover:text-teal-300 text-xs transition-colors cursor-pointer">Privacy Policy</a>
            <span className="text-teal-700">•</span>
            <a href="#" rel="nofollow" className="text-teal-400/60 hover:text-teal-300 text-xs transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
